import { render, staticRenderFns } from "./rolesAddOrEdit.vue?vue&type=template&id=1840b1ac&scoped=true"
import script from "./rolesAddOrEdit.vue?vue&type=script&lang=js"
export * from "./rolesAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./rolesAddOrEdit.vue?vue&type=style&index=0&id=1840b1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840b1ac",
  null
  
)

export default component.exports